import React, { useMemo } from 'react';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { Box, Button, Flex, Text } from '@chakra-ui/react';
import PropTypes from 'prop-types';

// After this many consecutive backend rejections (AGENT_PORTAL_GET_INSURANCE_REQUEST_FAILURE),
// stop offering the "Verify Email Address" button — it would just bounce the
// agent back into the same failing round trip — and surface an actionable
// message instead (DEV-3087).
const MAX_VERIFY_ATTEMPTS = 2;

function UnverifiedBlock({ currentUrlSlug, verifyFailureCount }) {
  const history = useHistory();
  const { url } = useRouteMatch();
  const apiToken = window.localStorage.getItem('portal-api-token');
  const apiTokenDate = window.localStorage.getItem('portal-api-token-date');
  const exhausted = verifyFailureCount >= MAX_VERIFY_ATTEMPTS;

  const message = useMemo(() => {
    if (exhausted) {
      return 'We couldn\'t confirm your access to this insured. Please use the link from your most recent '
        + 'verification email, or contact support if this continues.';
    }

    if (apiToken && (apiTokenDate <= Date.now())) {
      return 'Looks like your login timed out.  Please verify your email address to continue';
    }

    if (!apiToken) {
      return 'Looks like you need to verify your email address.  Please verify your email address to continue';
    }

    return 'We were unable to verify your access.  Please verify your email address to continue';
  }, [apiToken, apiTokenDate, exhausted]);

  return (
    <Flex direction="column" justifyContent="center" minH="50vh">
      <Text>{message}</Text>
      {!exhausted && (
        <Box justifyContent="center" maxW="200px" mx="auto" my={8}>
          <Button
            data-analytics-id="agent-portal-unverified-retry-email-verification-button"
            onClick={() => history.push(url.replace(currentUrlSlug, 'verify'))}
          >
            Verify Email Address
          </Button>
        </Box>
      )}
    </Flex>
  );
}

UnverifiedBlock.propTypes = {
  currentUrlSlug: PropTypes.string,
  verifyFailureCount: PropTypes.number
};

UnverifiedBlock.defaultProps = { verifyFailureCount: 0 };

export default UnverifiedBlock;
